import React  from "react";
import ReactDOM from "react-dom";
import BuyingLists from "./BuyingLists";


ReactDOM.render(<BuyingLists />,document.getElementById("root"));


